import { FilterOperator } from '../mql/operators';

export const isOperatorEmpty = (op: FilterOperator) =>
  op.value === 'isEmpty' || op.value === 'isNotEmpty';

export const resolveValueBasedOnBooleanOperator = (
  operator: FilterOperator,
  value?: unknown
) =>
  operator.value === 'isEmpty'
    ? true
    : operator.value === 'isNotEmpty'
      ? false
      : value;
